var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "no-gutters",
      class: {
        row: _vm.row
      }
    },
    [
      typeof _vm.label !== "undefined" && _vm.label !== null
        ? _c("div", { staticClass: "col-sm-12 col-md-4 text-sentence" }, [
            _vm._v(_vm._s(_vm.label) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "show-status" }, [
        _c("div", { class: _vm.status, on: { click: _vm.status_change } }, [
          _vm._v("\n            " + _vm._s(_vm.status) + "\n        ")
        ])
      ]),
      _vm._v(" "),
      _c("div", {
        class: {
          "col-sm-12 col-md-8":
            typeof _vm.label !== "undefined" && _vm.label !== null && _vm.row,
          col:
            (typeof _vm.label == "undefined" && _vm.row) ||
            (_vm.label == null && _vm.row)
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-752acbe5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-752acbe5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/base/BaseSwitchEvents.vue
// module id = 801
// module chunks = 0